// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedGoniometer_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 3C12.8284 3 13.5 2.32843 13.5 1.5 13.5.671573 12.8284 0 12 0 11.1716 0 10.5.671573 10.5 1.5 10.5 2.32843 11.1716 3 12 3ZM12 24C12.8284 24 13.5 23.3284 13.5 22.5 13.5 21.6716 12.8284 21 12 21 11.1716 21 10.5 21.6716 10.5 22.5 10.5 23.3284 11.1716 24 12 24ZM22.5 13.5C21.6716 13.5 21 12.8284 21 12 21 11.1716 21.6716 10.5 22.5 10.5 23.3284 10.5 24 11.1716 24 12 24 12.8284 23.3284 13.5 22.5 13.5ZM0 12C0 12.8284.671573 13.5 1.5 13.5 2.32843 13.5 3 12.8284 3 12 3 11.1716 2.32843 10.5 1.5 10.5.671573 10.5 0 11.1716 0 12ZM18.364 20.4845C17.7782 19.8987 17.7782 18.949 18.364 18.3632 18.9498 17.7774 19.8995 17.7774 20.4853 18.3632 21.0711 18.949 21.0711 19.8987 20.4853 20.4845 19.8995 21.0703 18.9498 21.0703 18.364 20.4845ZM3.51474 3.51551C2.92895 4.1013 2.92895 5.05105 3.51474 5.63683 4.10052 6.22262 5.05027 6.22262 5.63606 5.63683 6.22184 5.05105 6.22184 4.1013 5.63606 3.51551 5.05027 2.92973 4.10052 2.92973 3.51474 3.51551ZM3.51576 18.3649C4.10154 17.7791 5.05129 17.7791 5.63708 18.3649 6.22286 18.9507 6.22286 19.9004 5.63708 20.4862 5.05129 21.072 4.10154 21.072 3.51576 20.4862 2.92997 19.9004 2.92997 18.9507 3.51576 18.3649ZM20.4847 3.51529C19.8989 2.9295 18.9492 2.9295 18.3634 3.51529 17.7776 4.10107 17.7776 5.05082 18.3634 5.63661 18.9492 6.22239 19.8989 6.22239 20.4847 5.63661 21.0705 5.05082 21.0705 4.10107 20.4847 3.51529Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedGoniometer is a generated icon component.
 */
let IconMedGoniometer = IconMedGoniometer_1 = class IconMedGoniometer extends IconBaseElement {
    render() {
        return html `${IconMedGoniometer_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedGoniometer.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedGoniometer = IconMedGoniometer_1 = __decorate([
    customElement('zui-icon-med-goniometer')
], IconMedGoniometer);
export { IconMedGoniometer };
